import { getValidationErrorsString } from '@thanx/uikit/utils'
import { withFormsy } from 'formsy-react'
import { PassDownProps } from 'formsy-react/dist/withFormsy'
import React from 'react'
import BrameCampaignSelector from 'scenes/Cms/Content/AppNavigation/BottomNav/components/BrameCampaignSelector'

type FormsyBrameCampaignSelectorProps = {
  disabled?: boolean
}

const FormsyBrameCampaignSelector = (
  props: FormsyBrameCampaignSelectorProps &
    PassDownProps<number | string | undefined>
) => {
  const { disabled = false, value, setValue } = props

  // Convert the Formsy value (which could be string) to number for BrameCampaignSelector
  const isValidValue = value !== '' && value != null && !isNaN(Number(value))
  const numericValue: number | undefined = isValidValue
    ? Number(value)
    : undefined

  const handleChange = (newValue: number | undefined) => {
    setValue(newValue)
  }

  // BrameCampaignSelector already includes FormGroup and FormLabel,
  // so we just need to pass through the props and handle validation errors
  const validationErrors = getValidationErrorsString(props)

  return (
    <div>
      <BrameCampaignSelector
        value={numericValue}
        onChange={handleChange}
        disabled={disabled}
      />
      {validationErrors && (
        <div className="text-danger small mt-1">{validationErrors}</div>
      )}
    </div>
  )
}

export default withFormsy(FormsyBrameCampaignSelector)
